import PropTypes from 'prop-types';
import { SelectInput, required, useTranslate } from 'react-admin';
import { deploymentStatuses } from '@/components/newDevice/deploymentStatuses.js';

export const DeploymentStatusInput = ({ bulk = false }) => {
    const translate = useTranslate();
    const choices = deploymentStatuses(translate).concat([{ id: 'deployed', name: translate('resources.device.labels.deployed') }]);
    return (
        <SelectInput
            source='deploymentStatus'
            label={translate('resources.device.fields.deploymentStatus')}
            choices={choices}
            validate={bulk ? null : required(translate('common.validation.required'))}
            emptyText={translate('common.all')}
            fullWidth
        />
    );
};

DeploymentStatusInput.propTypes = {
    bulk: PropTypes.bool,
};
